<template>
<div class="user-coupon">
  <p>我的优惠券<span>（共<i>{{total}}</i>张）</span></p>
  <Tabs v-model="tab_name" :animated="false">
    <TabPane :label="valid_label" name="valid">
      <CouponValid @num="getValidNum"></CouponValid>
    </TabPane>
    <TabPane :label="expired_label" name="expired">
      <CouponExpired @num="getExpiredNum"></CouponExpired>
    </TabPane>
    <TabPane :label="already_label" name="already">
      <CouponAlready @num="getAlready_num"></CouponAlready>
    </TabPane>
  </Tabs>
</div>
</template>

<script>
import CouponValid from './components/CouponValid.vue'
import CouponExpired from './components/CouponExpired.vue'
import CouponAlready from './components/CouponAlready.vue'
import { getAddPuv } from 'js/addPuv.js'
export default {
  mixins: [getAddPuv],
  components: {
    CouponValid,
    CouponExpired,
    CouponAlready
  },
  data() {
    return {
      tab_name: 'valid',
      valid_num: 0,
      expired_num: 0,
      already_num: 0,
      valid_label: (h) => {
        return h('div', [
          h('span', '可用优惠券'),
          h('span', {class: 'spa1'}, '（'),
          h('span', {class: 'spa2'}, this.valid_num),
          h('span', {class: 'spa1'}, '张）'),
        ])
      },
      expired_label: (h) => {
        return h('div', [
          h('span', '过期优惠券'),
          h('span', {class: 'spa1'}, '（'),
          h('span', {class: 'spa2'}, this.expired_num),
          h('span', {class: 'spa1'}, '张）'),
        ])
      },
      already_label: (h) => {
        return h('div', [
          h('span', '已使用优惠券'),
          h('span', {class: 'spa1'}, '（'),
          h('span', {class: 'spa2'}, this.already_num),
          h('span', {class: 'spa1'}, '张）'),
        ])
      }
    }
  },
  computed: {
    user_key() {
      return this.$store.state.user_key
    },
    total() {
      return this.valid_num + this.expired_num + this.already_num
    }
  },
  methods: {
    getValidNum(val) {
      this.valid_num = Number(val)
    },
    getExpiredNum(val) {
      this.expired_num = Number(val)
    },
    getAlready_num(val) {
      this.already_num = Number(val)
    }
  },
  created() {
    let url = window.location.href
    this.getAddPuv(url)
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
.user-coupon
  width: 1200px
  margin: 0 auto
  padding: 30px 0 20px
  > p
    margin-bottom: 20px
    commonColor(#FFFFFF, #333333)
    font-size: 18px
    font-weight: 500
    span
      commonColor(#BCBDC1, #999999)
      font-size: 14px
      i
        color: rgba(250, 122, 80, 1)
        font-style: normal
  >>>.ivu-tabs-nav-scroll
    commonBgColor(#2A2F42, #FFFAF5)
    .ivu-tabs-tab
      width: 200px;
      commonColor( #BCBDC1, #999)
      text-align: center;
      padding: 15px 16px;
      &.ivu-tabs-tab-active
        commonBgColor(#1F2330, #ffffff);
        commonColor(#fff, #333);
        > div
          .spa1
            color: #999
          .spa2
            color: rgba(250, 122, 80, 1)
    .ivu-tabs-ink-bar
      top: 1px;
      background-color: rgba(250, 122, 80, 1)
  >>>.ivu-tabs-bar
    margin-bottom: 0;
  >>>.ivu-tabs-content
    commonBgColor(#1F2330, #fff)
</style>
